// extracted by mini-css-extract-plugin
export default {"Graphs__container":"App_Graphs__container__MhHll","App__container":"App_App__container__TMqZZ","Switch__container":"App_Switch__container__V+mmv","Switch":"App_Switch__DJCQk"};